import cn from "classnames";
import React from "react";
import { useLocation } from "react-router-dom";
import NodesSvg from "../../svgComponents/NodesSvg";
import PoolSvg from "../../svgComponents/PoolSvg";
import SwapSvg from "../../svgComponents/SwapSvg";
import xBullRunLogo from "./../../../assets/x-bull-run.png";
import NavigationLink from "./NavigationLink";
import ToggleButtonMobile from "./ToggleButtonMobile";
import TokensList from "./TokensList";

const BurgerMenu = ({
  toggleTheme,
  tokens,
  isMenuOpen,
  headerRef,
  closeHeaderModalMob,
}) => {
  const location = useLocation();
  return (
    <div className="block md:hidden">
      <div
        className={cn(
          "w-full h-dvh fixed top-0 transition-all ease-in-out duration-700 -right-full bg-semiBlack left-0 opacity-0 md:hidden",
          { "opacity-100 z-[999] blur-sm": isMenuOpen }
        )}
      />
      <div
        ref={headerRef}
        className={cn(
          "h-dvh fixed top-0 -right-full  z-[1000] w-3/4 sm:w-1/2 py-10 px-6 transition-all ease-in-out duration-700 opacity-0 flex flex-col justify-between  bg-lightGrayBlue dark:bg-[#080628] md:hidden",
          {
            "!right-0 opacity-100": isMenuOpen,
          }
        )}
      >
        <div className="flex flex-col gap-10">
          <img
            src={xBullRunLogo}
            width={"149px"}
            height={"51px"}
            alt="XBullRun logo"
          />
          <div className="flex flex-col gap-3">
            <NavigationLink
              label={"pool"}
              linkImage={<PoolSvg />}
              href={"https://pool.xbullrun.org"}
              isMenuOpen={isMenuOpen}
              closeBurgerMenu={closeHeaderModalMob}
            />
            {location.pathname === "/swap" ? (
              <NavigationLink
                label={"node"}
                linkImage={<NodesSvg />}
                href={"/node"}
                isMenuOpen={isMenuOpen}
                closeBurgerMenu={closeHeaderModalMob}
              />
            ) : (
              <NavigationLink
                label={"Swap"}
                linkImage={<SwapSvg />}
                href={"/swap"}
                isMenuOpen={isMenuOpen}
                closeBurgerMenu={closeHeaderModalMob}
              />
            )}
          </div>
        </div>
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-3">
            <ToggleButtonMobile toggleTheme={toggleTheme} />
          </div>
          <TokensList tokens={tokens} />
        </div>
      </div>
    </div>
  );
};

export default BurgerMenu;
